import { memo, useCallback } from 'react';
import { ICheckboxGroupItemProps, Icon, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { useTranslate } from '@agilepoint/wat-react';
import { PlatformIcon } from 'common';
import { PlatformSelectionFields, PlatformTypeWrapper } from '../styled-components';
import { AndroidBuildDetailsForm } from './android-build-details-form';
import { PlatformTypes } from '../steps';
import { IOSBuildDetailsForm } from './ios-build-details-form';
import { useKeyboardAccessibility } from 'common/hooks';

export const PlatformTypesForm = () => {
    const translate = useTranslate();
    const options = [{
        name: translate('modules.createNewApp.steps.platform.androidTitle'),
        value: { iconName: 'maa-android.solid', description: translate('modules.createNewApp.steps.platform.androidDescriptionTitle') },
        key: PlatformTypes.Android
    },
    {
        name: translate('modules.createNewApp.steps.platform.iosTitle'),
        value: { iconName: 'maa-ios-solid.svg', description: translate('modules.createNewApp.steps.platform.iosDescriptionTitle') },
        key: PlatformTypes.IOS
    }];

    const onRenderItem = useCallback((args: ICheckboxGroupItemProps) => <PlatformType {...args} />, []);
    return (
        <PlatformSelectionFields
            name='platformTypes'
            groupName='Platform Types'
            options={options}
            fieldOrientation="vertical"
            validationRules={{ required: translate('modules.createNewApp.steps.platform.platformValidateText') }}
            onRenderItem={onRenderItem} />
    );
};

const PlatformType = memo((props: ICheckboxGroupItemProps) => {
    const { toggleSelection, isSelected, itemData } = props;
    const { value, name, key } = itemData;
    const { elementRef } = useKeyboardAccessibility<HTMLDivElement>({ callback: toggleSelection });

    const renderBuildDetailsForm = () => (key === PlatformTypes.Android ? <AndroidBuildDetailsForm /> : <IOSBuildDetailsForm />);

    return (
        <PlatformTypeWrapper onClick={toggleSelection} tabIndex={0} elementRef={elementRef} $isSelected={isSelected} orientation='vertical' justifyContent={isSelected ? 'normal' : 'center'} >
            {isSelected ? <Icon className='ap-checkmark-container' iconName="ap-thick-checkmark.solid" iconSize='20' /> : <></>}
            <StackPanel alignment={isSelected ? 'flex-start' : 'center'} orientation='vertical' gap="20" width='100%'>
                <PlatformIcon $platform={value.iconName === 'maa-android.solid' ? 'Android' : 'iOS'} iconSize='48' iconName={value.iconName} />
                <StackPanel gap="4" orientation='vertical' alignment="inherit">
                    <Typography.H4 title={name}>{name}</Typography.H4>
                    <Typography.Medium title={value.description}>{value.description}</Typography.Medium>
                </StackPanel>
            </StackPanel>
            {isSelected ? renderBuildDetailsForm() : <></>}
        </PlatformTypeWrapper>
    );
});
